<template>
  <v-container 
    class="pt-0"
    fluid>
    <material-wizard
      v-model="tab"
      class="mx-auto wizard-bulldozerr"
      :title="title"
      :available-steps="tabsLiberadas"
      :wizzard-mixins-on="true"
      :tabs="tabs"
      max-width="1280"
      subtitle="Preencha as informações para gerar seu cálculo BulldozeRR."
      :loading="loading"
      @click:next="nextStep()"
      @click:prev="prevStep()"
    >
      <bulldozerr-wizard-tabs
        ref="WizardTab"
        @step-observer="updateTabStatus($event)"
        @save="save()"
      />
    </material-wizard>
  </v-container>
</template>

<script>
import pusherMixins from '@/mixins/pusherMixins';
import wizardMixins from '@/mixins/wizardMixins.js';
import BulldozerrService from '@/services/BulldozerrService.js';

export default {

  components: {
    MaterialWizard:       () => import('@/components/base/MaterialWizard.vue'),
    BulldozerrWizardTabs: () => import('@/components/bulldozerr/WizardTabs.vue')
  },
  mixins: [pusherMixins, wizardMixins],

  data: () => ({
    items: [],
    tabs: ['Início', 'Upload de Arquivos', 'ICMS', 'Banco de Compras', 'BDGD', 'AIS', 'Base Incremental', 'Obrigações Especiais'],
    tabsLiberadas: [],
    loading: false,
    tab: 0
  }),

  computed: {
    title() {
      return this.$route.params.id ? `Editando Cálculo BulldozeRR ${this.tipoConciliacao}` : 'Adicionar Cálculo BulldozeRR';
    }
  },

  methods: {
    save() {
      const data = this.$refs.WizardTab.saveData();

      this.loading = true;

      const postData = {
        nome: data.informacoesGerais.nome,
        parametros: JSON.stringify({
          data_inicial_analise: data.informacoesGerais.dataInicialAnalise,
          data_final_analise: data.informacoesGerais.dataFinalAnalise,
          id_empresa: data.informacoesGerais.empresaSelecionada,
          etapas: ['todas'],
          periodo_recuperacao: data.informacoesIcms.periodoRecuperacaoSelecionado,
          flg_fluxo_pagamento: data.informacoesBancoCompras.fluxoPagamentoSelecionado,
          vl_odc: data.informacoesBancoCompras.valorOdc,
          flg_imp_bdgd: data.informacoesBdgd.flagImportarBdgd,
          flg_imp_sdi: data.informacoesAis.flagImportarAis,
          flg_de_para: data.informacoesBaseIncremental.checkboxRoaOuAis,
          flg_dep_dia: data.informacoesBaseIncremental.checkboxDepreciarDia,
          flg_dep_mes: data.informacoesBaseIncremental.checkboxDepreciarMes,
          tx_amt_oe: data.informacoesObrigacoesEspeciais.valorTaxaMediaSelecionado,
          flg_legislacao: data.informacoesBancoCompras.flagLegislacao
        }),
        caminho_tmp: data.caminhoTmpUpload
      };
      
      BulldozerrService.save(postData)
        .then(() => {
          this.$toast.success('Analise BulldozeRR salva com sucesso.', '', { position: 'topRight' });
          this.$router.push({ name: 'Bulldozerr Histórico'});
        })
        .catch(err => {
          console.error(err);
          this.$toast.error('Falha ao salvar o cálculo BulldozeRR', '', { position: 'topRight' });
        })
        .finally(() => this.loading = false);
    }
  }
};
</script>

<style>
  .wizard-bulldozerr .v-tabs-bar__content {
    font-size: 10px !important;
  }
</style>
